import PersonContainer from "../../../Component/Application/Persons/person-container";

const PersonsPage = () => {
    return (
        <div className="page-body">
            <PersonContainer />
        </div>
    );
};

export default PersonsPage;